// @format
export enum Resource {
  PullZone = 'pullzone',
  Statistic = 'statistics',
  Billing = 'billing',
}
